// TODO 这里的方法是用来将微软的语音列表请求下来，并将数据处理后放到页面进行展示，只在需要更新数据的时候进行处理,
// TODO 通过接口请求的数据放在 public/text-to-speech/input/voices-list
// TODO TTSVoiceList: https://eastus.tts.speech.microsoft.com/cognitiveservices/voices/list
// TODO voiceList: https://eastus.api.cognitive.microsoft.com/texttospeech/acc/v3.0-beta1/vcg/voices
// TODO voice-info.json 是后台跑脚本生成的对应voice的头像和描述

import FJNetworkStore from '../store/FJNetworkStore.js';
import FJConfig from '../config/FJConfig.js';
import FJConstant from '../constants/FJConstant.js';
import FJLocalStore from '../store/FJLocalStore.js';
import FJStringUtil from './FJStringUtil.js';
import FJTextToSpeechData from '../config/dataConfig/FJTextToSpeechData.js';

const voiceOriginPath = '/public/resource/text-to-speech/input/voices-list.json'; // 这个只会在本地调用
const voiceInfoPath = `/public/resource/text-to-speech/input/voice-info.json`; // 这个只会在本地调用

const FJTextToSpeechUtil = {
    version: '1.0.0.0',

    getData: async function (url) {
        try {
            const response = await fetch(url, {
                method: 'GET',
            });
            return await response.json();
        } catch (e) {
            console.log(e);
        }
    },

    dealData: async function () {
        const { TTSVoiceList: voiceList, voiceList: voices } = await this.getData(voiceOriginPath);
        const voiceInfoList = await this.getData(voiceInfoPath);

        // 处理语音 voices
        const tempVoices = [];
        const nameSet = new Set();
        voices.forEach(item => {
            if (item.samples.styleSamples && item.samples.styleSamples.length > 0) {
                tempVoices.push({
                    ShortName: item.shortName,
                    styleSamples: item.samples.styleSamples,
                    description: item.description,
                });
                nameSet.add(item.shortName);
            }
        });

        const result = this.dealVoiceList(voiceList, tempVoices);
        const { langList, voiceObj, styleObj } = result;

        // 页面显示的国家列表
        const languageList = this.getLangList(langList);

        // 将voiceInfoList中的描述加入到 voiceObj
        for (const key in voiceObj) {
            const itemList = voiceObj[key];

            for (let i = 0; i < itemList.length; i++) {
                const innerItem = itemList[i];
                const voiceInfo = voiceInfoList.find(item => item.name === innerItem.id);
                if (voiceInfo) {
                    innerItem.description = JSON.parse(voiceInfo.description).description;
                }
            }
        }

        console.log({ languageList, voiceObj, styleObj });
        // TODO 将languageList, voiceObj, styleObj 放到/public/resource/text-to-speech/
    },

    getLangList: function (langList) {
        const tempLangList = {};

        const newLanguageList = [];

        langList.forEach(item => {
            const key = item.value.split('-')[0];
            if (!tempLangList[key]) {
                tempLangList[key] = [];
            }
            tempLangList[key].push(item);
        });

        Object.keys(tempLangList).forEach(item => {
            newLanguageList.push({
                value: item,

                label: tempLangList[item][0].label.slice(0, tempLangList[item][0].label.indexOf(' (')),
                languageKey: item + '-speech-service',
                innerLangList: tempLangList[item],
            });
        });

        // 自定的语言列表
        // newLanguageList.push({
        //   value: "en",
        //   label: "English",
        //   languageKey: "en-speech-service",
        //   innerLangList: [{ value: "en-fj" }],
        // });

        return newLanguageList;
    },

    dealVoiceList: function (voiceList, wavList) {
        // 排序
        const sorted = voiceList.sort(function (a, b) {
            return `${a.LocaleName}${a.VoiceType}`.localeCompare(`${b.LocaleName}${b.VoiceType}`);
        });

        let langList = [],
            voiceObj = {},
            styleObj = {},
            rolePlayObj = {},
            secondaryObj = {};

        for (let i = 0; i < sorted.length; i++) {
            const element = sorted[i];
            let displayName = element.DisplayName;

            // 已经弃用
            if (element.Status === 'Deprecated') {
                continue;
            }

            if (!voiceObj[element.Locale]) {
                voiceObj[element.Locale] = [];
                langList.push({
                    value: element.Locale,
                    label: element.LocaleName,
                    languageKey: `${element.Locale.toLowerCase()}-speech-service`,
                });
            }

            // // 需求要求去掉(Neural)
            // if (element.VoiceType === 'Neural') {
            //     displayName += ' (Neural)';
            // }

            if (element.LocalName !== element.DisplayName) {
                displayName += ' - ' + element.LocalName;
            }

            // 不需要显示预览
            // if (element.Status === 'Preview') {
            //     displayName += ' - ' + localizedResources.ttsPreview;
            // }

            const findWavItem = wavList.find(item => item.ShortName === element.ShortName);
            const styleSamples = findWavItem ? findWavItem.styleSamples : [];

            voiceObj[element.Locale].push({
                value: element.ShortName,
                label: displayName,
                id: element.ShortName,
                text: displayName,
                gender: element.Gender,
                url: styleSamples[0]?.audioFileEndpointWithSas,
                languageInfo: {
                    value: element.Locale,
                    label: element.LocaleName,
                    languageKey: `${element.Locale.toLowerCase()}-speech-service`,
                },
            });

            // 如果音频有问题就不显示播放按钮
            try {
                let styleList = [];
                if (element.StyleList) {
                    styleList = element.StyleList.map(item => {
                        const findItem = styleSamples.find(sample => sample.styleName === item);
                        return {
                            id: item,
                            text: item,
                            url: findItem?.audioFileEndpointWithSas,
                        };
                    });
                    styleList.unshift({
                        id: 'general',
                        text: 'general',
                        url: styleSamples[0]?.audioFileEndpointWithSas,
                    });
                } else {
                    styleList = [
                        {
                            id: 'general',
                            text: 'general',
                            url: styleSamples[0]?.audioFileEndpointWithSas,
                        },
                    ];
                }
                styleObj[element.ShortName] = styleList;
            } catch (e) {
                styleObj[element.ShortName] = element.StyleList
                    ? element.StyleList.map(item => {
                          return { id: item, text: item };
                      })
                    : [{ id: 'general', text: 'general' }];
            }

            rolePlayObj[element.ShortName] = element.RolePlayList;
            secondaryObj[element.ShortName] = element.SecondaryLocaleList;
        }

        return {
            langList,
            voiceObj,
            styleObj,
            rolePlayObj,
            secondaryObj,
        };
    },

    getUsedCreditByTextLength: function (textLength = 0) {
        // 每320字节1积分
        const num = textLength * (1 / 320);
        return parseFloat(num.toFixed(3));
    },

    setRecentUseVoiceList: function (list) {
        localStorage.setItem('tts_used_voice_list', JSON.stringify(list));
    },

    getRecentUseVoiceList: function () {
        try {
            const listJson = localStorage.getItem('tts_used_voice_list');
            return JSON.parse(listJson) || [];
        } catch (e) {
            return [];
        }
    },

    checkIsEqual: function (viewInfo, generateInfo = {}) {
        if (!generateInfo.generationType && !generateInfo?.text && !generateInfo.voiceInfo) {
            return false;
        }
        if (
            viewInfo.generationType === generateInfo.generationType &&
            viewInfo.text.trim() === generateInfo?.text?.trim() &&
            JSON.stringify(viewInfo.voiceInfo) === JSON.stringify(generateInfo.voiceInfo)
        ) {
            return true;
        } else {
            return false;
        }
    },

    /**
     * @description 整合微软列表和自定义预设列表
     * @returns {Promise<{styleObj: *, voiceObj: *, languageList: *}>}
     */
    getVoiceStyleList: async function () {
        const { languageList, voiceObj, styleObj } = await FJNetworkStore.getDataByJson(FJConfig.voicePath);
        // 自定义预设列表
        const voiceList = await FJNetworkStore.getDataByJson(FJConfig.voicePathOfFLEXCLIP);

        voiceList.forEach(item => {
            const innerItem = languageList.find(innerItem => innerItem.value === item.value);
            innerItem.innerLangList = [...item.innerLangList, ...innerItem.innerLangList];
            const key = item.value + '-flexclip';
            voiceObj[key] = item.list;
        });

        return {
            languageList,
            voiceObj,
            styleObj,
        };
    },

    /**
     * @description 根据语言获取语音列表
     * @param voiceInfo
     * @param languageList
     * @param languageValue
     * @returns {*[]}
     */
    getVoiceListByLanguage: function (voiceInfo, languageList, languageValue) {
        const selectLanguageList = languageList.find(item => item.value === languageValue);
        if (!selectLanguageList) {
            return [];
        }
        const innerLangList = selectLanguageList.innerLangList;
        const list = [];

        // 按照 innerLangList 的顺序遍历
        innerLangList.forEach(innerLang => {
            const key = innerLang.value;
            const itemList = voiceInfo[key];
            if (itemList) {
                itemList.forEach(item => {
                    list.push({
                        ...item,
                    });
                });
            }
        });
        // !!item.url 微软中有声音才显示
        return list.filter(item => !!item.url || item.type === FJConstant.CLONE_BY_FLEX_CLIP);
    },

    /**
     * @description 获取自定义预设图片的url
     * @param value
     * @returns {string}
     */
    getVoiceStyleImgUrl: function (value) {
        return FJConfig.voiceCloneAvatarPath + value + '.png';
    },

    /**
     * @description 获取自定义预设audio的url
     * @param value
     * @returns {string}
     */
    getVoiceStyleAudioUrl: function (value) {
        return FJConfig.voiceCloneAudioPath + value + '.mp3';
    },

    /**
     * @description 获取语音列表展示信息
     * @param {*} info
     * @param {*} fromType
     * @param {*} options
     * @returns
     */
    getVoiceItemShowInfo: function (info, fromType, options = {}) {
        const { favoriteList = [], loadingFavoriteIdList = [], isFavorite = false } = options;
        switch (fromType) {
            case FJConstant.MICROSOFT: {
                const { value, text, description, url, languageInfo = {} } = info;
                const languageLabel = FJLocalStore._(languageInfo.languageKey);

                return {
                    audioUrl: url,
                    imgUrl: FJStringUtil.getTextToSpeechImgUrl(value),
                    description: FJLocalStore._(description.replaceAll(' ', '-').toLowerCase()),
                    name: text,
                    value: value,
                    languageLabel: languageLabel,
                    isFavorite: favoriteList.find(item => item === value) || isFavorite,
                    isFavoriteLoading: loadingFavoriteIdList.find(item => item === value),
                };
            }
            case FJConstant.CLONE_BY_SELF: {
                const { audioUrl, avatar, name, lang, id } = info;
                const showLang = FJTextToSpeechData.LANGUAGE_LIST.find(item => item.value === lang)?.label || 'English';
                return {
                    audioUrl: audioUrl,
                    imgUrl: FJConfig.profilePath + avatar + '.png',
                    description: null,
                    name: name,
                    value: id,
                    languageLabel: showLang,
                    isFavorite: false,
                };
            }
            case FJConstant.CLONE_BY_FLEX_CLIP: {
                const { value, description, languageInfo = {}, label } = info;
                const languageLabel = FJLocalStore._(languageInfo.languageKey);
                return {
                    audioUrl: FJTextToSpeechUtil.getVoiceStyleAudioUrl(value),
                    imgUrl: FJTextToSpeechUtil.getVoiceStyleImgUrl(value),
                    description: FJLocalStore._(description.replaceAll(' ', '-').toLowerCase()),
                    name: label,
                    value: value,
                    languageLabel: languageLabel,
                    isFavorite: favoriteList.find(item => item === value) || isFavorite,
                    isFavoriteLoading: loadingFavoriteIdList.find(item => item === value),
                };
            }
            default:
        }
    },

    getFavoriteVoiceListByIds: function (voiceInfo, favoriteList = []) {
        const list = [];
        for (const key in voiceInfo) {
            const itemList = voiceInfo[key];
            for (let i = 0; i < itemList.length; i++) {
                const item = itemList[i];
                list.push({
                    ...item,
                });
            }
        }
        return favoriteList?.map(id => list.find(item => (item.value || item.id) === id));
    },

    /**
     * @description 返回上传时候的音频信息
     * @param info
     * @returns {{audioUrl: string, audioText: *}|{audioUrl, audioText}}
     */
    getUploadAudioInfo: function (info) {
        switch (info.generationType) {
            case FJConstant.CLONE_BY_SELF:
                return {
                    audioUrl: info.voiceInfo.audioUrl,
                    audioText: info.voiceInfo.readText,
                };
            case FJConstant.CLONE_BY_FLEX_CLIP:
                return {
                    audioUrl: FJTextToSpeechUtil.getVoiceStyleAudioUrl(info.voiceInfo.value),
                    audioText: info.voiceInfo.languageInfo.readText,
                };
        }
    },

    /**
     * @description 埋点用
     * @returns {string}
     */
    getToolName: function () {
        let toolName = '';
        const localPath = window.location.pathname;
        const keys = localPath.split('/');
        const info = {
            'text-to-speech': 'text_to_speech',
            'voice-cloning': 'voice_cloning',
        };
        for (const key in info) {
            const result = keys.find(value => value && value === key);
            if (result) {
                toolName = info[key];
                break;
            }
        }
        return toolName;
    },
};

export default FJTextToSpeechUtil;
